import classNames from 'classnames'
import React from 'react'
import styles from './ItemTile.module.scss'
import { Skeleton } from '@/tools/ui'

export const ItemTileSkeleton = () => (
  <div className={styles.itemTile}>
    <div className={styles.imageContainer}>
      <Skeleton animated className={styles.skeletonContainer}>
        <svg
          className={classNames('pintxo-skeleton-shape')}
          height="100%"
          width="100%"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect height="100%" width="100%" x="0" y="0" />
        </svg>
      </Skeleton>
    </div>
    <div className={styles.description}>
      <Skeleton animated>
        <svg
          className="pintxo-skeleton-shape"
          height="48"
          width="100%"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <rect height="22" rx="10" ry="10" width="100%" x="0" y="0" />
            <rect height="22" rx="10" ry="10" width="40%" x="0" y="26" />
          </g>
        </svg>
      </Skeleton>
    </div>
  </div>
)
